import { render, staticRenderFns } from "./notary-process.vue?vue&type=template&id=49715077&scoped=true"
import script from "./notary-process.vue?vue&type=script&lang=js"
export * from "./notary-process.vue?vue&type=script&lang=js"
import style0 from "./notary-process.vue?vue&type=style&index=0&id=49715077&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49715077",
  null
  
)

export default component.exports